/**
 * Struttura della sidebar del backoffice Maitime (`/admin`), raggruppata per
 * famiglie (SPEC §1.1). Le route delle pagine esistenti NON cambiano: qui si
 * definisce solo come sono organizzate nella nav laterale.
 */

import {
  Activity,
  Bot,
  CalendarClock,
  CalendarPlus,
  Database,
  FileText,
  GanttChart,
  LayoutDashboard,
  LayoutGrid,
  LineChart,
  ListChecks,
  type LucideIcon,
  Megaphone,
  MessageSquare,
  Receipt,
  ScrollText,
  Server,
  Shield,
  Upload,
  Users,
} from "lucide-react";

export interface AdminNavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Chiave del conteggio notifiche da mostrare come badge (opzionale). */
  badgeTipo?: string;
}

export interface AdminNavGroup {
  label?: string;
  items: AdminNavItem[];
}

export const ADMIN_NAV: AdminNavGroup[] = [
  {
    items: [{ label: "Cruscotto", to: "/admin", icon: LayoutDashboard }],
  },
  {
    label: "Cliente",
    items: [
      { label: "Bacheca", to: "/admin/bacheca", icon: Megaphone, badgeTipo: "bacheca" },
      { label: "Conversazioni", to: "/admin/conversazioni", icon: MessageSquare },
      { label: "Documenti", to: "/admin/documenti", icon: FileText },
      { label: "Attività", to: "/admin/feed", icon: Activity, badgeTipo: "feed" },
      // Le due leve della Panoramica: il KPI «Prossimo incontro» e la casella
      // «Questa settimana». Stanno sotto Cliente perché è roba che il cliente
      // vede, non configurazione di sistema.
      { label: "Questa settimana", to: "/admin/settimana", icon: ListChecks },
      { label: "Incontri", to: "/admin/incontri", icon: CalendarPlus },
    ],
  },
  {
    label: "Accessi",
    items: [
      { label: "Utenti", to: "/admin/utenti", icon: Users },
      { label: "Ruoli e permessi", to: "/admin/ruoli", icon: Shield },
    ],
  },
  {
    label: "Dati e moduli",
    items: [
      { label: "M1 · Upload dati", to: "/admin/m1/upload", icon: Upload },
      { label: "Stato moduli", to: "/admin/moduli", icon: LayoutGrid },
      { label: "Timeline", to: "/admin/gantt", icon: GanttChart },
    ],
  },
  {
    label: "Agenti AI",
    items: [{ label: "Agenti", to: "/admin/agenti", icon: Bot }],
  },
  {
    label: "Economia",
    items: [
      { label: "Scadenze e pagamenti", to: "/admin/economia/scadenze", icon: CalendarClock },
      { label: "Fatture", to: "/admin/economia/fatture", icon: Receipt },
    ],
  },
  {
    label: "Sistema",
    items: [
      { label: "Stato sistema", to: "/admin/sistema", icon: Server },
      { label: "Log", to: "/admin/logs", icon: ScrollText },
      { label: "Osservabilità AI", to: "/admin/ai-ops", icon: LineChart },
      { label: "Audit", to: "/admin/audit", icon: Database },
    ],
  },
];

/** Mappa route → titolo per il breadcrumb dell'header admin. */
export const ADMIN_BREADCRUMB: Record<string, string> = {
  "/admin": "Cruscotto",
  "/admin/bacheca": "Bacheca",
  "/admin/conversazioni": "Conversazioni",
  "/admin/documenti": "Documenti",
  "/admin/feed": "Attività",
  "/admin/utenti": "Utenti",
  "/admin/ruoli": "Ruoli e permessi",
  "/admin/moduli": "Stato moduli",
  "/admin/m1/upload": "M1 · Upload dati",
  "/admin/agenti": "Agenti AI",
  "/admin/economia/scadenze": "Scadenze e pagamenti",
  "/admin/economia/fatture": "Fatture",
  "/admin/sistema": "Stato sistema",
  "/admin/logs": "Log",
  "/admin/ai-ops": "Osservabilità AI",
  "/admin/audit": "Audit",
};
